module.exports = __webpack_public_path__ + "pc/img/work_detail0.1c59b7c6.png";